/* Diamond Kaftan Rose — Theme JS */
document.addEventListener('DOMContentLoaded', function () {

  // Header scroll
  var hdr = document.getElementById('dkr-header');
  if (hdr) {
    window.addEventListener('scroll', function () {
      hdr.classList.toggle('scrolled', window.scrollY > 40);
    }, { passive: true });
  }

  // Hamburger
  var burger = document.getElementById('dkr-burger');
  var mobile = document.getElementById('dkr-mobile');
  if (burger && mobile) {
    burger.addEventListener('click', function () {
      var open = mobile.classList.toggle('open');
      burger.setAttribute('aria-expanded', String(open));
    });
    document.addEventListener('click', function (e) {
      if (hdr && !hdr.contains(e.target)) {
        mobile.classList.remove('open');
        burger.setAttribute('aria-expanded', 'false');
      }
    });
  }

  // Hero Slideshow
  var slides = document.querySelectorAll('.dkr-slide');
  var dotsEl = document.getElementById('dkr-dots');
  if (slides.length > 1 && dotsEl) {
    var cur = 0, timer = null;
    slides.forEach(function (_, i) {
      var b = document.createElement('button');
      b.className = 'dkr-dot' + (i === 0 ? ' on' : '');
      b.setAttribute('aria-label', 'Bild ' + (i + 1));
      b.addEventListener('click', function () { go(i, true); });
      dotsEl.appendChild(b);
    });
    var dots = dotsEl.querySelectorAll('.dkr-dot');
    function go(n, reset) {
      slides[cur].classList.remove('active'); dots[cur].classList.remove('on');
      cur = (n + slides.length) % slides.length;
      slides[cur].classList.add('active'); dots[cur].classList.add('on');
      if (hero) hero.classList.toggle('info-active', slides[cur].classList.contains('dkr-slide-info'));
      if (reset) { clearInterval(timer); tick(); }
    }
    function tick() { timer = setInterval(function () { go(cur + 1, false); }, 5500); }
    tick();
    var tx = 0, hero = document.querySelector('.dkr-hero');
    if (hero) {
      hero.addEventListener('touchstart', function (e) { tx = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend',   function (e) { var d = e.changedTouches[0].clientX - tx; if (Math.abs(d) > 40) go(d < 0 ? cur + 1 : cur - 1, true); }, { passive: true });
    }
  }

  // Filter
  document.querySelectorAll('.dkr-filter').forEach(function (btn) {
    btn.addEventListener('click', function () {
      document.querySelectorAll('.dkr-filter').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
      var cat = this.dataset.cat;
      document.querySelectorAll('.dkr-card').forEach(function (c) {
        c.classList.toggle('hide', cat !== 'alle' && c.dataset.cat !== cat);
      });
    });
  });

  // Produkt-Galerie
  var mainImg = document.getElementById('dkr-main-img');
  if (mainImg) {
    document.querySelectorAll('.dkr-pthumb').forEach(function (th) {
      th.addEventListener('click', function () {
        document.querySelectorAll('.dkr-pthumb').forEach(function (t) { t.classList.remove('active'); });
        this.classList.add('active');
        if (this.dataset.src) { mainImg.src = this.dataset.src; mainImg.alt = this.dataset.alt || ''; }
      });
    });
  }

  // Varianten
  document.querySelectorAll('.dkr-vbtn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var grp = this.closest('.dkr-pvbtns');
      if (grp) grp.querySelectorAll('.dkr-vbtn').forEach(function (b) { b.classList.remove('active'); });
      this.classList.add('active');
    });
  });

  // Add to cart
  var form = document.getElementById('dkr-pform');
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Wird hinzugefügt…'; }
      fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
        .then(function (r) { if (!r.ok) throw new Error(); return r.json(); })
        .then(function () {
          if (btn) btn.textContent = '✓ Im Warenkorb';
          cartCount();
          setTimeout(function () { if (btn) { btn.disabled = false; btn.textContent = 'In den Warenkorb'; } }, 2600);
        })
        .catch(function () { if (btn) { btn.disabled = false; btn.textContent = 'Fehler — erneut versuchen'; } });
    });
  }

  // Cart count
  function cartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var el = document.getElementById('dkr-cart-count');
        if (el) el.textContent = d.item_count > 0 ? '(' + d.item_count + ')' : '';
      }).catch(function () {});
  }
  cartCount();

  // Scroll reveal
  var revealEls = document.querySelectorAll('.dkr-reveal');
  function revealVisible() {
    revealEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight + 80) el.classList.add('in');
    });
  }
  if ('IntersectionObserver' in window) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); obs.unobserve(e.target); }
      });
    }, { threshold: 0, rootMargin: '0px 0px 80px 0px' });
    revealEls.forEach(function (el) { obs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('in'); });
  }
  revealVisible();
  window.addEventListener('scroll', revealVisible, { passive: true });
  window.addEventListener('load', revealVisible);

  // Smooth scroll
  document.querySelectorAll('a[href^="#"]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var id = this.getAttribute('href');
      var t = id.length > 1 ? document.querySelector(id) : null;
      if (t) { e.preventDefault(); t.scrollIntoView({ behavior: 'smooth', block: 'start' }); if (mobile) mobile.classList.remove('open'); }
    });
  });


});
